import React, { useEffect, useState } from "react";
import { Button, DataGrid } from "devextreme-react";
import { Column, Editing, Pager, Paging, Scrolling } from "devextreme-react/data-grid";

import CustomTextBox from "../../../components/customTextBox/CustomTextBox";
import CustomButton from "../../../components/customButton/CustomButton";
import "./ProjectCategoryTab.scss";
import {
  postCategoryData,
  getCategoryData,
  editCat,
  deleteCat,
} from "../../../api/settingsApi";

import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import { useAuth } from "../../../contexts/auth";
import { confirm } from "devextreme/ui/dialog";

export default function ProjectCategoryTab() {
  const { user } = useAuth();

  const [newCategory, setNewCategory] = useState("");
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await getCategoryData();
      setCategories(response.data);
    } catch {
      ToastDisplayer("error", "Failed to fetch categories");
    }
  };

  const addCategory = async () => {
    if (newCategory == null || newCategory == "") {
      return ToastDisplayer("error", "Please add category name.");
    }

    if (!newCategory.trim()) return;


    try {
      const newCategoryData = {
        ticketcategoryname: newCategory,
        companytransid: user.companytransid,
        ticketisdeleted: 0,
      };

      await postCategoryData(newCategoryData);

      ToastDisplayer("success", "Category added successfully");

      fetchCategories();
      setNewCategory("");
    } catch (error) {

      ToastDisplayer("error", error.message);
    }
  };

  const deleteCategory = async (e) => {
    e.cancel = true; // STOP default deletion immediately

    try {
      const result = await confirm(
        "Are you sure you want to delete this project Category?"
      );

      if (!result) return;

      await deleteCat(e.data.transid);

      ToastDisplayer("success", "Category deleted successfully");

      fetchCategories(); // refresh data manually
    } catch (error) {
      ToastDisplayer("error", error.message);
    }
  };

  const editCategory = async (updatedData) => {
    await editCat(updatedData.transid, updatedData);
    fetchCategories();
  };

  return (
    <>
      <div className="add-category-section">
        <CustomTextBox
          placeholder="Enter Project Name"
          label="Project Name"
          value={newCategory}
          onChange={(e) => setNewCategory(e?.value || "")}
        />

        <Button
          className="addBtn"
          height={42}
          icon="add"
          text="Add Project"
          type="default"
          onClick={addCategory}
        />
      </div>

      <DataGrid
        style={{ height: "calc(100vh - 390px)" }}
        className="custGrid"
        dataSource={categories}
        onRowUpdating={(e) => editCategory({ ...e.oldData, ...e.newData })}
        onRowRemoving={deleteCategory}
      >

        <Pager
          visible={true}
          allowedPageSizes={[10, 20, 30]}
        // showPageSizeSelector={true}
        />
        <Paging defaultPageSize={10} />
        <Scrolling mode="virtual" />
        <Editing mode="row" allowUpdating={true} allowDeleting={true} confirmDelete={false} />

        <Column dataField="ticketcategoryname" caption="Project Name" />
      </DataGrid>
    </>
  );
}
